var _defs, _g, _path, _path2, _g2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcoDelete(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Grupo_3898",
    "data-name": "Grupo 3898",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 57.173,
    height: 57.173,
    viewBox: "0 0 57.173 57.173",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Combined_Shape",
    "data-name": "Combined Shape",
    d: "M3.444,23.361A3.485,3.485,0,0,1,.473,18.116L10.316,1.684a3.486,3.486,0,0,1,5.968,0l9.852,16.448a3.485,3.485,0,0,1-2.993,5.229Zm8.863-20.48L2.476,19.295a1.162,1.162,0,0,0,.981,1.742H23.13a1.167,1.167,0,0,0,1-.587,1.151,1.151,0,0,0,.006-1.14L14.293,2.884a1.171,1.171,0,0,0-.994-.56A1.154,1.154,0,0,0,12.307,2.881Zm.17,14.329a1.163,1.163,0,1,1,.822.34A1.161,1.161,0,0,1,12.478,17.21Zm-.34-4.308V8.254a1.162,1.162,0,0,1,2.324,0V12.9a1.162,1.162,0,1,1-2.324,0Z",
    fill: "#fff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_3893",
    "data-name": "Grupo 3893"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2264",
    "data-name": "Grupo 2264"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_31",
    "data-name": "Elipse 31",
    cx: 28.586,
    cy: 28.586,
    r: 28.586,
    fill: "#ff0027",
    opacity: 0.212
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_2962",
    "data-name": "Caminho 2962",
    d: "M22,0A22,22,0,1,1,0,22,22,22,0,0,1,22,0Z",
    transform: "translate(6.348 6.23)",
    fill: "#ff5f5f"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_3894",
    "data-name": "Grupo 3894",
    transform: "translate(14.617 13.979)",
    style: {
      isolation: "isolate"
    }
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Combined_Shape-2",
    "data-name": "Combined Shape",
    d: "M3.444,23.361A3.485,3.485,0,0,1,.473,18.116L10.316,1.684a3.486,3.486,0,0,1,5.968,0l9.852,16.448a3.485,3.485,0,0,1-2.993,5.229Zm8.863-20.48L2.476,19.295a1.162,1.162,0,0,0,.981,1.742H23.13a1.167,1.167,0,0,0,1-.587,1.151,1.151,0,0,0,.006-1.14L14.293,2.884a1.171,1.171,0,0,0-.994-.56A1.154,1.154,0,0,0,12.307,2.881Zm.17,14.329a1.163,1.163,0,1,1,.822.34A1.161,1.161,0,0,1,12.478,17.21Zm-.34-4.308V8.254a1.162,1.162,0,0,1,2.324,0V12.9a1.162,1.162,0,1,1-2.324,0Z",
    transform: "translate(0 0)",
    fill: "#fff"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_de_m\\xE1scara_16",
    "data-name": "Grupo de m\\xE1scara 16",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "_Icon_Color",
    "data-name": "\\u21B3 Icon Color",
    width: 27.595,
    height: 27.595,
    transform: "translate(-1.011 -2.18)",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoDelete);
export default __webpack_public_path__ + "static/media/ico-delete.d43f0055cf3368988958ca2b1f682f98.svg";
export { ForwardRef as ReactComponent };